import React, { useState, useEffect } from "react";
import RatingComponent from "../../utils/StarsComponent";
import { Button } from "@material-ui/core";
import EventIcon from "@material-ui/icons/Event";
import DescriptionIcon from "@material-ui/icons/Description";
import Tags from "../Tags";
import MessageIcon from "@material-ui/icons/Message";
import { useHistory } from "react-router-dom";
import ProfileLogo from "../../../images/profile-2.svg";
//flags images
import NICFlag from "../../../images/nicaragua-flag.png";
import CRCFlag from "../../../images/cr-flg.png";
import BahFlag from "../../../images/bahamas-flag.png";
import USAFlag from "../../../images/usa-flag.png";
import JAMFlag from "../../../images/jamaica-flag.png";

export default function ProviderCard(props) {
  let history = useHistory();

  const handleClick = () => {
    history.push({
      pathname: "/patient/appointments/create",
      state: {
        providerId: props.providerId,
        providerUserId: props.providerUserId,
      },
    });
  };
  const handleClickDetails = () => {
    history.push({
      pathname: `provider/details/${props.id}`,
      state: props.providerImg,
    });
  };

  const handleClickTextConsultation = () => {
    history.push({
      pathname: `/patient/textconsultation`,
      state: { providerId: props.providerId },
    });
  };

  const mathCountryFlag = (country) => {
    switch (country) {
      case "CRC":
        return (
          <img className="flag-size rounded" src={CRCFlag} alt="CRCFlag" />
        );
      case "USA":
        return (
          <img className="flag-size rounded" src={USAFlag} alt="USAFlag" />
        );
      case "NIC":
        return (
          <img className="flag-size rounded" src={NICFlag} alt="NICFlag" />
        );
      case "TBH":
        return (
          <img className="flag-size rounded" src={BahFlag} alt="BahFlag" />
        );
      case "JAM":
        return (
          <img className="flag-size rounded" src={JAMFlag} alt="JAMFlag" />
        );

      default:
        return (
          <img
            className="flag-size rounded"
            src={CRCFlag}
            alt="CRCFlagDefault"
          />
        );
    }
  };

  return (
    <>
      <div className="d-flex justify-content-around shadow p-3 mb-5 bg-white rounded-lg-custom col-sm-12">
        {/* Photo and Star section */}
        <div className="text-center col-md-4 col-sm-12">
          <img
            src={props.profileImage || ProfileLogo}
            alt="avatar"
            className="rounded-circle img-fluid w-50"
          />
          <div className="mt-2">
            <RatingComponent editRate={false} />
          </div>
          <div className="text-center">
            {/* Tag Component to render the specialities */}
            <Tags tags={props.specialty || []} />
          </div>
        </div>
        {/* section divider  */}
        <div className="d-flex row align-content-center">
          <hr className="divider-main" />
        </div>
        <div className="d-flex row justify-content-center align-items-center p-5">
          <div className="col-md-12">
            <h4 className="pl-2 font-weight-bold">
              <span>{props.title || "Dr."} </span>
              {props.fullname || "John Smith Doe"}
              <span className="w-10-custom">
                {" "}
                - {mathCountryFlag(props.country)}
              </span>
            </h4>
          </div>
          <div className="col-md-12">
            <p className="text-justify p-2 blockquote-footer card-doctor-summary">
              {props.summary || "Professional resume not Provided yet 😞"}
            </p>
          </div>
          <div className="col-md-12">
            <Button
              variant="contained"
              color="primary"
              size="medium"
              className="w-auto m-1"
              startIcon={<DescriptionIcon />}
              //className="w-30-custom"
              onClick={handleClickDetails}
            >
              Detail
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              className="w-auto m-1"
              startIcon={<EventIcon />}
              //className={classes.submit}
              onClick={handleClick}
            >
              Set an Appointment
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="medium"
              className="w-auto m-1"
              startIcon={<MessageIcon />}
              //className={classes.submit}
              onClick={handleClickTextConsultation}
            >
              Text Consultation
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
